import { IUser } from 'main/gql/user'
import { userType, UserType } from 'main/util/user'

import { directorDashboardHomePath, directorDashboardWebsitePath, familyProgramsPath } from '.'

export function homePath() {
  return '/'
}
export function userDashboardPath() {
  return '/dashboard'
}

export function guestHomePath() {
  return '/home'
}

export function corpPath() {
  return '/corp'
}

export function searchPath() {
  return '/search'
}

export function maybeUserHomePath(user?: IUser) {
  const maybeUser = user || window?.lego?.user
  if (!maybeUser) {
    return guestHomePath()
  }

  const type = userType(maybeUser)
  const migratedToWsCenters = maybeUser?.schoolhouse?.migratedToWsCenters || false
  const directorHomePath = migratedToWsCenters
    ? directorDashboardWebsitePath()
    : directorDashboardHomePath()

  return type === UserType.Director ? directorHomePath : familyProgramsPath()
}
